import { z } from 'zod';
import { defineEndpoint } from '../define';
import { DeviceOsSchema, DeviceRowSchema, InventoryFieldsSchema } from './shapes';

export const CreateDeviceBodySchema = z
  .object({
    name: z.string().trim().min(1).max(120),
    model: z.string().trim().max(120).default(''),
    os: DeviceOsSchema,
    serial: z.string().trim().max(120).default(''),
    imei: z.string().trim().max(40).default(''),
    notes: z.string().trim().max(2000).default(''),
    assignToSelf: z.boolean().optional(),
  })
  .merge(InventoryFieldsSchema);

export type CreateDeviceBody = z.infer<typeof CreateDeviceBodySchema>;

export const CreateDeviceResponseSchema = z.object({
  data: DeviceRowSchema,
});

export const createDevice = defineEndpoint({
  method: 'POST',
  path: '/v1/devices',
  params: z.object({}),
  query: z.object({}),
  body: CreateDeviceBodySchema,
  response: CreateDeviceResponseSchema,
  successStatus: 201,
});
